var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEntreprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.35714 16.0429C8.35714 15.265 8.97975 14.6337 9.75 14.6337H18.1071C18.8774 14.6337 19.5 15.265 19.5 16.0429C19.5 16.8208 18.8774 17.4521 18.1071 17.4521H9.75C8.97975 17.4521 8.35714 16.8208 8.35714 16.0429ZM18.1071 20.2706H9.75C8.97975 20.2706 8.35714 20.902 8.35714 21.6799C8.35714 22.4578 8.97975 23.0891 9.75 23.0891H18.1071C18.8774 23.0891 19.5 22.4578 19.5 21.6799C19.5 20.902 18.8774 20.2706 18.1071 20.2706ZM18.1071 25.9076H9.75C8.97975 25.9076 8.35714 26.5389 8.35714 27.3168C8.35714 28.0947 8.97975 28.7261 9.75 28.7261H18.1071C18.8774 28.7261 19.5 28.0947 19.5 27.3168C19.5 26.5389 18.8774 25.9076 18.1071 25.9076ZM18.1071 31.5446H9.75C8.97975 31.5446 8.35714 32.1759 8.35714 32.9538C8.35714 33.7317 8.97975 34.363 9.75 34.363H18.1071C18.8774 34.363 19.5 33.7317 19.5 32.9538C19.5 32.1759 18.8774 31.5446 18.1071 31.5446ZM39 38.5908C39 39.3687 38.3774 40 37.6071 40H1.39286C0.622607 40 0 39.3687 0 38.5908C0 37.8129 0.622607 37.1815 1.39286 37.1815H2.78571V11.2769C2.78571 10.2016 3.37629 9.23628 4.32482 8.75572L21.0391 0.30028C21.911 -0.139403 22.9223 -0.0943072 23.7496 0.422884C24.577 0.940076 25.07 1.83635 25.07 2.82141V13.2244H33.4272C34.9635 13.2244 36.2129 14.4885 36.2129 16.0429V37.1815H37.6058C38.376 37.1815 39 37.8129 39 38.5908ZM25.0714 16.0429V37.1815H33.4286V16.0429H25.0714ZM5.57143 37.1815H22.2857V2.82141L5.57143 11.2769V37.1815Z",
    fill: "var(--fill-0, #119ED9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 38.5908C39 39.3687 38.3774 40 37.6071 40H1.39286C0.622607 40 0 39.3687 0 38.5908C0 37.8129 0.622607 37.1815 1.39286 37.1815H2.78571V11.2769C2.78571 10.2016 3.37629 9.23628 4.32482 8.75572L21.0391 0.30028C21.911 -0.139403 22.9223 -0.0943071 23.7496 0.422884C24.577 0.940076 25.07 1.83635 25.07 2.82141V13.2244H33.4272C34.9635 13.2244 36.2129 14.4885 36.2129 16.0429V37.1815H37.6058C38.376 37.1815 39 37.8129 39 38.5908ZM25.0714 16.0429V37.1815H33.4286V16.0429H25.0714ZM5.57143 37.1815H22.2857V2.82141L5.57143 11.2769V37.1815Z",
    fill: "url(#paint0_linear_0_75)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_75",
    x1: -0.236951,
    y1: 1.74217,
    x2: 45.9776,
    y2: 16.9879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEntreprise);
export default __webpack_public_path__ + "static/media/profile-entreprise.9f69989a6ff0f6a3fe9d87d885dbc270.svg";
export { ForwardRef as ReactComponent };